export default __webpack_public_path__ + "static/media/mouse-click-left-drag.ffd38e69.svg";